(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@material/tab-indicator", [], factory);
	else if(typeof exports === 'object')
		exports["tab-indicator"] = factory();
	else
		root["mdc"] = root["mdc"] || {}, root["mdc"]["tab-indicator"] = factory();
})(this, function() {
return 